import "./App.css";
import { Component } from "react";
import GifSearch from "./components/Search/Searcg.jsx";
import { Gift } from "./components/Search/Gift.jsx";

class App extends Component {
  state = {
    keyword: "cat",
  };

  handleSearch = (word) => {
    this.setState({ keyword: word });
  };

  render() {
    return (
      <div className="app">
        <GifSearch onSearch={this.handleSearch} />
        <Gift keyword={this.state.keyword} />
      </div>
    );
  }
}

export default App;
